if(typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      const targetCart = document.querySelector(".cart__summary");
      if (targetCart) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          for (const record of recordList) {
            if (record.target.id === "cart-summary") {
                console.log(123);       
                BSS_B2B.observer.cartSubject.listenCartCheckout();
              break;
            }
          }
        });
        mutationObserver.observe(targetCart, { childList: true, subtree: true });
      }
    }, 3000)
  }
  
}